import React, { useEffect, useState } from "react";
import axiosClient from "../../utils/axiosClient";
import { MenuItem, Select, FormControl, FormHelperText } from "@mui/material";
import { useRouter } from "next/router";
import "../Category/category.css";

function Type() {
  const router = useRouter();
  const { industry, slug, categoryPage, type } = router.query;
  const categorySlug = slug && Array.isArray(slug) ? slug[0] : null;
  const typeSlug = slug && Array.isArray(slug) ? slug[1] : null;
  const industryValue = industry || null;

  const [typeModel, setTypeModel] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState("");

  // console.log("Type Slug from type select", type);

  useEffect(() => {
    if (type) {
      setSelectedType(type);
      console.log(">>>>>>>", type);
    }
    fetchTypes();
  }, [type, categoryPage, typeSlug]);

  const fetchTypes = async () => {
    try {
      // setSelectedType("");
      let url = "GetAllType";
      if (industryValue && categorySlug) {
        url = `GetAllTypeByIndustryCategory/${industryValue}/${categorySlug}`;
      } else if (categoryPage) {
        url = `GetAllTypeByCategory/${categoryPage}`;
      } else {
        url = "GetAllType";
      }
      const res = await axiosClient.get(url);
      if (res) {
        setTypeModel({ data: res });
      } else {
        setTypeModel({ data: [] });
      }
    } catch (error) {
      console.log("Error fetching types:", error);
      setTypeModel({ data: [] });
    }
  };

  useEffect(() => {
    if (type) {
      const matchingVal = typeModel.data.find((item) => item.slugName === type);
      if (matchingVal) {
        setSelectedType(matchingVal.id);
      } else {
        setSelectedType("");
      }
    }
  }, [typeModel]);

  const handleTypeChange = (event) => {
    // debugger;
    const selectedValue = event.target.value;
    const newValue = typeModel.data.find((item) => item.id === selectedValue);
    if (newValue) {
      if (industryValue && categorySlug) {
        router.push(`/${industryValue}/${categorySlug}/${newValue.slugName}`);
      } else if (!industryValue && categoryPage) {
        router.push(`/type/${newValue.slugName}`);
      } else {
        router.push(`/type/${newValue.slugName}`);
      }
    } else {
      // router.push(`/${industry}`);
    }
  };

  const handleClear = () => {
    setSelectedType("");
    if (industryValue && categorySlug) {
      router.push(`/${industryValue}/${categorySlug}`);
    } else {
      router.push(`/Inventory`);
    }
  };

  const capitalize = (str) => str.replace(/\b\w/g, (l) => l.toUpperCase());

  return (
    <FormControl
      fullWidth
      variant="outlined"
      disabled={!industryValue || !categorySlug}
    >
      <Select
        value={selectedType}
        onChange={handleTypeChange}
        displayEmpty
        fullWidth
        style={{
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
          height: "45px",
          overflow: "hidden",
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
              width: 270,
              zIndex: 1300,
            },
          },
          disableScrollLock: true,
        }}
        inputProps={{ "aria-label": "Select a Type" }}
        renderValue={(selected) =>
          selected
            ? typeModel.data.find((item) => item.id === selected)?.name
            : "Select a Type"
        }
      >
        <MenuItem value="">
          <span>Select a Type</span>
        </MenuItem>
        {typeModel.data.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {capitalize(item.name)} ({item.itemCount})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default Type;
